import {FC} from 'react'
import CheckoutListApp from '../components/CheckOutListApp'

const HeaderCheckoutAppPanel: FC = () => {
  return (
    <>
      <CheckoutListApp />
    </>
  )
}

export {HeaderCheckoutAppPanel}
